/*
*  Site content. Copy is word-for-word from the original Wix site (www.candlewoods.co.za) - check with the client before rewording
*/

export const SITE_NAME = "Candlewoods GH";
export const SITE_URL = "https://www.candlewoods.co.za";
export const DEFAULT_DESCRIPTION = "Candlewoods Guesthouse is a prestigious establishment that provides opulent accommodation in the Centurion/Midrand area, Gauteng.";

export const ROUTES = {
  HOME: "/",
  ABOUT: "/about-us",
  ROOMS: "/rooms",
  CONFERENCES: "/conferences",
  GALLERY: "/gallery",
  BOOK: "/book-now",
  CONTACT: "/contact",
  TERMS: "/t-c",
  DISCLAIMER: "/disclaimer",
  PRIVACY: "/privacy-policy",
};

//Semper booking engine, embedded on the Book Now page (same venue / channel as on Wix)
export const BOOKING_ENGINE_URL = "https://services.semper.co.za/BookingEngine/full-layout/date-selection?VenueID=15985&ChannelID=1";

export const VENUE_LINK = "https://www.candlewoodsvenue.co.za/";

export const NAV_LINKS = [
  { label: "Home", path: ROUTES.HOME },
  { label: "About Us", path: ROUTES.ABOUT },
  { label: "Rooms", path: ROUTES.ROOMS },
  { label: "Conferences", path: ROUTES.CONFERENCES },
  { label: "Gallery", path: ROUTES.GALLERY },
  { label: "Book Now", path: ROUTES.BOOK },
  { label: "Contact", path: ROUTES.CONTACT },
];

export const LEGAL_LINKS = [
  { label: "Terms & Conditions", path: ROUTES.TERMS },
  { label: "Disclaimer", path: ROUTES.DISCLAIMER },
  { label: "Privacy Statement", path: ROUTES.PRIVACY },
];

export const CONTACT_DETAILS = {
  TEL: { label: "+27 (0)12 687 9904", link: "tel:+27126879904" },
  CELL: { label: "+27 (0)74 587 4178", link: "tel:+27745874178" },
  EMAIL: "info@candlewoods.co.za",
  ADDRESS: ["1796 Stonehedge Road", "Candlewoods Country Estate", "Centurion, Gauteng, South Africa"],
  MAP_LINK: "https://www.google.com/maps/search/?api=1&query=Candlewoods+Guest+House,+1796+Stonehedge+Road,+Louwlardia,+Centurion",
  MAP_EMBED: "https://maps.google.com/maps?q=Candlewoods%20Guest%20House%2C%201796%20Stonehedge%20Road%2C%20Louwlardia%2C%20Centurion&z=14&output=embed",
  WHATSAPP_LINK: "https://wa.me/27745874178",
  FACEBOOK_LINK: "https://www.facebook.com/CandlewoodsGuesthouse",
  INSTAGRAM_LINK: "https://www.instagram.com/candlewoodsguesth/",
  LEKKESLAAP_LINK: "https://www.lekkeslaap.co.za/akkommodasie/candlewoods-guest-house",
};

export const CREDIT = { label: "TapX", link: "https://www.tap-x.com/" };

//Photo behind each page (fixed, so the page content scrolls over it - as on Wix)
export const BACKGROUNDS = {
  HOME: "/images/backgrounds/home.webp",
  PAGE: "/images/backgrounds/page.webp",
  ROOMS: "/images/backgrounds/rooms.webp",
  GALLERY: "/images/backgrounds/gallery.webp",
  CONTACT: "/images/backgrounds/contact.webp",
};

/* ------------------------------ HOME ------------------------------ */

export const HOME = {
  TITLE: "Candlewoods Guesthouse",
  DESCRIPTION: "Located in the Gauteng region, Candlewoods Guesthouse is a prestigious establishment that provides opulent accommodation in the Centurion/Midrand area.",
  WELCOME_TITLE: "Welcome to Candlewoods Guesthouse",
  WELCOME: "Located in the Gauteng region, Candlewoods Guesthouse is a prestigious establishment that provides opulent accommodation in the Centurion/Midrand area. Guests can indulge in the lavish amenities and impeccable service offered by this esteemed guest house. Whether visiting for business or pleasure, Candlewoods Guesthouse guarantees a truly luxurious experience during your stay in Centurion, Gauteng.",
  CARDS: [
    {
      title: "CONFERENCES",
      text: "We provide flexible packages including half-day, full-day. Feel free to review our pricing and packages, and reach out to us for a customized quote.",
      path: ROUTES.CONFERENCES,
    },
    {
      title: "ROOMS",
      text: "Explore the exquisite accommodations at Candlewoods Guesthouse, featuring luxurious rooms for your comfort and enjoyment.",
      path: ROUTES.ROOMS,
    },
    {
      title: "WEDDING VENUE",
      text: "Planning a remarkable party or event? Candlewoods Boutique Venue, within walking distance of Candlewoods Guesthouse, provides the perfect setting for an unforgettable experience.",
      href: VENUE_LINK,
    },
  ],
  STRIP: { src: "/images/home/entrance.webp", alt: "The covered entrance to Candlewoods Guesthouse" },
  TESTIMONIALS: [
    { quote: "Ons geniet dit om elke keer na ons “2de” huis terug te keer.", author: "Aubrie en Frans Olivier" },
    { quote: "Perfect. Love it!", author: "Genlife" },
    { quote: "Great venue, great service, great location – really a home away from home.", author: "Alex Hart" },
    { quote: "As always amazing! We love this place!", author: "Kowie and Adele Jacobs" },
    { quote: "Definite home away from home. Will definitely be back", author: "Mohammed – Epol" },
    { quote: "One of my favourite stays during business travel!", author: "Danica – Delheim Wines" },
  ],
};

/* ------------------------------ ABOUT ------------------------------ */

export const ABOUT = {
  TITLE: "About Us",
  DESCRIPTION: "Candlewoods Guesthouse is nestled in the heart of a rich heritage site in Candlewoods Country Estate, Centurion - a Victorian Style building surrounded by beautiful gardens.",
  HEADING: "Discover Royal Hospitality at Candlewoods Guesthouse: A Tranquil Oasis in Centurion",
  COLUMNS: [
    "Candlewoods Guesthouse is nestled in the heart of a rich heritage site in Candlewoods Country Estate, Centurion. It is a Victorian Style building with pit roofs and wooden windows. The interior is stylishly decorated with rich fabrics and crisp white linen.",
    "Surrounded by beautiful gardens and a great view over Centurion our guest would find peace and quiet away from the hustle & bustle of the city. Candlewoods Guesthouse is situated close to Centurion Mall, Super Sport Park , Pretoria City Centre, 5km away from Mediclinic Midstream, Midrand and JHB for those guests who want to experience the city vibe.",
    "Whether you are on a business trip, an overnight guest, a leisure guest or a bride-to-be, we will treat you with “Royal Hospitality”.",
  ],
  SLIDES: [
    { src: "/images/about/about-01.webp", alt: "The Candlewoods Guesthouse sign on the Victorian-style building" },
    { src: "/images/about/about-02.webp", alt: "Lounge with red velvet armchairs" },
    { src: "/images/about/about-03.webp", alt: "Dining room table with silver candlesticks" },
  ],
};

/* ------------------------------ ROOMS ------------------------------ */

const roomPhotos = (slug, name, count) => Array.from({ length: count }, (v, i) => ({
  src: `/images/rooms/${slug}/${String(i + 1).padStart(2, "0")}.webp`,
  alt: `${name} - photo ${i + 1} of ${count}`,
}));

export const ROOMS = {
  TITLE: "Our Rooms",
  META_TITLE: "Rooms",
  DESCRIPTION: "10 beautiful luxurious rooms in the main house, a self-catering house with 3 Provençal inspired rooms and a fully equipped bridal cottage - all with DSTV, en-suite bathrooms and wireless internet.",
  INTRO: [
    "At Candlewoods Guesthouse, we have 10 beautiful luxurious rooms within the MAIN HOUSE and one SELF-CATERING HOUSE with 3 self-catering rooms with Provencál inspired interiors. Candlewoods Guesthouse also boasts a fully equipped BRIDAL COTTAGE with all needed amenities. There is No-Loadshedding at Candlewoods Guesthouse.",
    "All the rooms are non-smoking and come with first-class amenities, such as DSTV, en-suite bathrooms and wireless internet.",
  ],
  LIST: [
    {
      id: "queen-victoria",
      name: "Queen Victoria",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with patio", "En-suite bathroom"],
      photos: roomPhotos("queen-victoria", "Queen Victoria", 2),
    },
    {
      id: "copper-room",
      name: "Copper Room",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with patio", "En-suite bathroom"],
      photos: roomPhotos("copper-room", "Copper Room", 6),
    },
    {
      id: "lady-carlyle",
      name: "Lady Carlyle",
      features: ["Sleeps 1", "3/4 bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with patio", "En-suite bathroom (shower only)"],
      photos: roomPhotos("lady-carlyle", "Lady Carlyle", 3),
    },
    {
      id: "sugar-bird",
      name: "Sugar Bird",
      features: ["Sleeps 1", "3/4 bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with Patio", "En-suite bathroom (shower only)"],
      photos: roomPhotos("sugar-bird", "Sugar Bird", 4),
    },
    {
      id: "memory-lane",
      name: "Memory Lane",
      features: ["Sleeps 1", "3/4 bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with patio", "En-suite bathroom (shower only)"],
      photos: roomPhotos("memory-lane", "Memory Lane", 5),
    },
    {
      id: "sterling-room",
      name: "Sterling Room",
      features: ["Sleeps 2", "Queen bed", "Desk & Chair in room", "Coffee Station", "Ground Floor with patio", "En-suite bathroom (shower only)"],
      photos: roomPhotos("sterling-room", "Sterling Room", 4),
    },
    {
      id: "royal-doulton",
      name: "Royal Doulton",
      features: ["Sleeps 2", "Queen bed", "Desk & Chair in room", "Coffee Station", "First Floor with balcony", "En-suite bathroom"],
      photos: roomPhotos("royal-doulton", "Royal Doulton", 5),
    },
    {
      id: "prince-albert",
      name: "Prince Albert",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station", "First Floor no balcony", "En-suite bathroom"],
      photos: roomPhotos("prince-albert", "Prince Albert", 4),
    },
    {
      id: "rose-petal",
      name: "Rose Petal",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station", "First Floor with balcony", "En-suite bathroom"],
      photos: roomPhotos("rose-petal", "Rose Petal", 2),
    },
    {
      id: "wedgewood-room",
      name: "Wedgewood Room",
      features: ["Sleeps 1", "3/4 bed", "Desk & Chair in room", "Coffee Station", "First Floor no balcony", "En-suite bathroom"],
      photos: roomPhotos("wedgewood-room", "Wedgewood Room", 4),
    },
    {
      id: "van-gogh-room",
      name: "Van Gogh Room",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station & mini-kitchenette", "Ground Floor with patio", "En-suite bathroom"],
      photos: roomPhotos("van-gogh-room", "Van Gogh Room", 5),
    },
    {
      id: "monet-room",
      name: "Monet Room",
      features: ["Sleeps 2", "Two 3/4 size beds", "Desk & Chair in room", "Coffee Station & mini-kitchenette", "First Floor with balcony", "En-suite bathroom"],
      photos: roomPhotos("monet-room", "Monet Room", 5),
    },
    {
      id: "renoir-room",
      name: "Renoir Room",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station & mini-kitchenette", "First Floor with balcony", "En-suite bathroom"],
      photos: roomPhotos("renoir-room", "Renoir Room", 5),
    },
    {
      id: "bridal-cottage",
      name: "Bridal Cottage",
      features: ["Sleeps 2", "Queen size bed", "Desk & Chair in room", "Coffee Station & kitchenette", "En-suite bathroom", "Lounge"],
      photos: roomPhotos("bridal-cottage", "Bridal Cottage", 13),
    },
  ],
};

/* ------------------------------ CONFERENCES ------------------------------ */

export const CONFERENCES = {
  TITLE: "Conferences",
  DESCRIPTION: "The perfect venue for smaller, more intimate conferences or meetings - 10 to 22 attendees, with flexible half-day and full-day packages.",
  HEADING: "The perfect venue for smaller, more intimate conferences or meetings",
  COLUMNS: [
    "Our conference facility can accommodate a minimum of 10, up to a maximum of 22 attendees, depending on your preferred seating arrangement (cinema, U-shape, classroom, or boardroom).",
    "We provide flexible packages including half-day, full-day. Feel free to review our pricing and packages, and reach out to us for a customized quote.",
    "We approach each conference with a balance of professionalism and personal care, ensuring that every meeting becomes an experience of excellence.",
  ],
  VENUE_TEXT: "For larger conferences, events, functions, and weddings, we invite you to explore Candlewoods Boutique Venue at ",
  VENUE_LINK_LABEL: "www.candlewoodsvenue.co.za",
  SLIDES: [
    { src: "/images/conferences/conference-01.webp", alt: "Conference room set up boardroom style with a projector screen" },
    { src: "/images/conferences/conference-02.webp", alt: "Conference room tables in a U-shape" },
    { src: "/images/conferences/conference-03.webp", alt: "Coffee station with cups and a coffee machine" },
  ],
  PACKAGES_TITLE: "Our Packages",
  PACKAGES: [
    {
      title: "FULL DAY PACKAGE",
      items: [
        "08h00 – 17h00",
        "Arrival Tea/ Coffee / Juice & Morning Snack",
        "Mid-morning Tea / Coffee / Juice & Mid-morning Snacks",
        "Lunch / Juice / Tea / Coffee",
        "Mid-afternoon Tea / Coffee / Juice and Confectioneries",
        "Bottled water and mints on the tables",
      ],
    },
    {
      title: "HALF DAY PACKAGE:",
      items: [
        "08h00 – 13h00 / 11h00 -17h00",
        "Lunch OR Breakfast / Juice / Tea / Coffee",
        "Bottled water and mints on the tables",
        "Mid Morning/Mid Afternoon tea/coffee/juice & snacks/confectioneries",
      ],
    },
  ],
  PACKAGES_IMAGE: { src: "/images/conferences/packages.webp", alt: "Brass samovar and the guest book at reception" },
  PRICING_LABEL: "See Pricing",
  PRICING_FILE: "/files/candlewoods-conference-pricing.pdf",
};

/* ------------------------------ GALLERY ------------------------------ */

//Descriptions (alt text) written for screen readers / Google - Wix only had file names
const GALLERY_ALTS = [
  "The Candlewoods Guesthouse sign on the building",
  "Front entrance with the door open to reception",
  "The guesthouse and its formal garden",
  "Room keys laid out at reception",
  "Covered carport and paved driveway",
  "Covered entrance with steps up to the front door",
  "Entrance hall leading to the lounge",
  "Front entrance framed by cycads",
  "Lounge with red sofas and leather armchairs",
  "Gable of the guesthouse with the Candlewoods sign",
  "The guesthouse behind the rose garden",
  "Garden and trees in front of the guesthouse",
  "Breakfast room with tables by the windows",
  "Coffee machine and cups at the coffee station",
  "Tea and coffee box at the coffee station",
  "Bar counter with bar stools",
  "Conference room with a projector screen",
  "Coffee counter and round table with flowers",
  "Long dining table with a candlestick",
  "Dining table with silver candlesticks",
  "Entrance hall with a wingback chair and round table",
  "Conference room set up boardroom style",
  "Conference tables and chairs",
  "Lounge with red velvet armchairs",
  "Brass samovar and the guest book",
  "Hall table with an ornate mirror and orchids",
  "Reception office with portraits on the wall",
  "Notice board and grading plaque at the entrance",
  "Front door between the entrance pillars",
  "Lounge with a grey sofa and yellow ottoman",
  "Double room with floral linen",
  "Twin room with two 3/4 beds",
  "Corner bath in an en-suite bathroom",
  "Double basin vanity in an en-suite bathroom",
  "Sitting area with a wicker chair",
  "Lounge with leather sofas and a TV",
  "Round white table and two chairs",
  "Seating corner in a room",
  "Gold sunburst mirrors above a TV",
  "Fresh fruit platter",
  "Bathroom with a bath and a shower",
  "Lounge with a silver mirror and teal cushions",
  "Kitchenette with canisters and a kettle",
  "Garden path between hedges",
  "Passage with rugs and an antique mirror",
  "Fireplace with a wooden mantel",
  "Passage to the rooms",
  "Ornate lamp with magazines",
  "Gate with a sign for The Suburban",
  "Patio and swimming pool",
  "Swimming pool and covered patio",
  "Outdoor table beside the pool",
  "Swimming pool and paving",
  "Dining area in front of a fireplace",
  "Bar with a TV and glass cabinets",
];

export const GALLERY = {
  TITLE: "Gallery",
  DESCRIPTION: "Photos of Candlewoods Guesthouse in Centurion's historic Candlewoods Country Estate - the rooms, gardens, pool, lounges and conference room.",
  INTRO: "Discover Candlewoods Guesthouse Gallery, nestled in Centurion's historic Candlewoods Country Estate. Housed in a Victorian-style building with rich fabrics and crisp white linen, our tranquil haven dates back to 1859, originally owned by Rasmus Erasmus. Surrounded by captivating gardens and offering a scenic view of Centurion, our guests escape the city's hustle. Conveniently located near Centurion Mall, Super Sport Park, Pretoria City Centre, Midrand, and JHB, experience \"Royal Hospitality\" on your business trip, overnight stay, leisure getaway, or as a bride-to-be.",
  PHOTOS: GALLERY_ALTS.map((alt, i) => {
    const n = String(i + 1).padStart(2, "0");
    return { src: `/images/gallery/gallery-${n}.webp`, thumb: `/images/gallery/thumbs/gallery-${n}.webp`, alt };
  }),
};

/* ------------------------------ BOOK NOW ------------------------------ */

export const BOOK = {
  TITLE: "Book Now",
  DESCRIPTION: "Check availability and book your room at Candlewoods Guesthouse, Centurion, online.",
};

/* ------------------------------ CONTACT ------------------------------ */

export const CONTACT = {
  TITLE: "Contact Us",
  META_TITLE: "Contact",
  DESCRIPTION: "Contact Candlewoods Guesthouse, 1796 Stonehedge Road, Candlewoods Country Estate, Centurion. Tel: +27 (0)12 687 9904, E-mail: info@candlewoods.co.za",
  NAME: "Candlewoods\nGuesthouse",
  SUCCESS: "Thanks for submitting!",
};

/* ------------------------------ LEGAL PAGES ------------------------------ */

export const TERMS = {
  TITLE: "Terms & Conditions",
  META_TITLE: "T&C's",
  SECTIONS: [
    {
      title: "ACCEPTANCE",
      text: ["All bookings accepted by Candlewoods Guesthouse are subject to these Terms and Conditions that are deemed to have been accepted in full by the Client/Guest. Payment of a deposit also indicates acceptance of these Terms and Conditions."],
    },
    {
      title: "GENERAL",
      text: ["Staying at Candlewoods Guest House is not intended to confer possession on the Client/Guest or to create the relationship of landlord and tenant between us and the Client/Guest. The Client/Guest will not be entitled to any form of tenancy. The Client/Guest confirms that they will not be occupying the serviced unit as their only or principal home."],
    },
    {
      title: "RESERVATIONS & PAYMENT",
      text: ["Your booking is only confirmed when we email written confirmation of booking following receipt of payment of the deposit. When a booking is made, 50% of the total invoice is required in advance to confirm the reservation. The balance (if any), of the booking charge is to be paid six weeks prior to the arrival date. If we do not receive full payment by this time, the reservation may be canceled and a percentage of the deposit withheld. The Client/Guest may be liable for the balance of the booking. When a booking is made less than six weeks prior to the arrival date, the full amount invoiced is required to confirm the reservation. Payment must be made in South African Rand (ZAR) and must be clear of all bank charges, exchange rate variations and any other deductions. We only accept EFT or bank-to-bank transfer to our account. Under no circumstances will accommodation be provided until we have received full payment of the booking. Failure to pay in accordance with the agreed terms of payment may result in loss of your booking."],
    },
    {
      title: "CANCELLATION POLICY",
      text: [
        "In the event of cancellation, the following rules shall apply:",
        "• 30 days and more prior to arrival : 0% cancellation fee\n• 7 days prior to arrival : 50% cancellation fee\n• 24 hours or less prior to arrival : 75 - 100% cancellation fees",
        "** WRITTEN CANCELLATIONS WILL BE ACCEPTED",
      ],
    },
    {
      title: "ARRIVALS & DEPARTURES",
      text: ["Rooms and cottages are available for occupation after 14h00 on the day of arrival. Rooms must be vacated and keys returned by 10h00 on the day of departure. If there is a delay in vacating the serviced unit beyond 10h00, a full day's rental may be charged to the Client/Guest. Early arrival and late departures are possible if the room concerned is not required."],
    },
    {
      title: "PROPERTY USE & CONDITIONS",
      text: ["The Client/Guest is responsible for taking all reasonable care of the premises. Any breakage or damage must be reported to us without delay. Candlewoods Guesthouse will not be held responsible for any personal injury, loss or damage to personal effects howsoever arising at the lodge or its grounds. Smoking is not permitted in the guesthouse or cottages."],
    },
  ],
};

export const DISCLAIMER = {
  TITLE: "Disclaimer",
  SECTIONS: [
    {
      text: [
        "The information contained in this website is provided by Candlewoods Guesthouse and while we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose.",
        "Any reliance you place on such information is therefore strictly at your own risk. In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arise out of, or in connection with, the use of this website. Through this website you are able to link to other websites which are not under the control of Candlewoods Guesthouse.",
        "We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them. Every effort is made to keep the website up and running smoothly. However, Candlewoods Guesthouse takes no responsibility for, and will not be liable for the website being temporarily unavailable due to technical issues beyond our control.",
      ],
    },
  ],
};

export const PRIVACY = {
  TITLE: "Privacy Policy",
  SECTIONS: [
    {
      text: ["We are committed to ensuring that your information is secure."],
    },
    {
      title: "WILL INFORMATION BE SHARED WITH THIRD PARTIES?",
      text: ["No. Candlewoods Guesthouse does not share any individual information you provide through the Booking Enquiry with third parties (except with your approval through the use of this Service). Candlewoods Guesthouse may release specific information about your account to comply with valid legal process such as a search warrant, subpoena or court order, or in special cases such as a physical threat to you or others."],
    },
    {
      title: "IS MY PERSONAL INFORMATION SECURE?",
      text: ["Yes, Candlewoods Guesthouse is deeply committed to your security. We use state-of-the-art technology to keep your personal information as secure as possible."],
    },
    {
      title: "WHAT HAPPENS IF THIS POLICY CHANGES?",
      text: ["If it becomes necessary for us to materially change this policy, we will provide prominent notice to those who use our service."],
    },
  ],
};
